module.exports = __webpack_public_path__ + "img/0-93.a1ceb4cc.jpg";